import type { Quote } from "./types";
import { createQuoteStory } from "./types";

export const sedekahBaqarah261: Quote = {
  id: "sedekah-baqarah-261",
  name: "Perumpamaan Sedekah",
  emoji: "🌱",
  category: "Sedekah & Kebaikan",
  description:
    "Perumpamaan orang yang menginfakkan hartanya di jalan Allah seperti **sebutir biji yang menumbuhkan tujuh tangkai**, setiap tangkai berisi seratus biji.",
  detail:
    "Ayat ini menggambarkan betapa besarnya balasan Allah bagi orang yang bersedekah. Satu kebaikan bisa **dilipatgandakan hingga 700 kali** bahkan lebih. Allah Maha Luas pemberian-Nya dan Maha Mengetahui siapa yang ikhlas.",
  tldr: "Sedekah satu biji, Allah balas 700 kali lipat — bahkan lebih.",
  story: createQuoteStory("Perumpamaan Sedekah", "🌱", [
    { hook: {
      title: "Pernah ragu mau sedekah karena merasa belum cukup?",
      body: "Padahal Allah kasih **jaminan balasan** yang bikin kamu gak akan rugi...",
    } },
    { source: {
      arabic: "مَّثَلُ الَّذِينَ يُنفِقُونَ أَمْوَالَهُمْ فِي سَبِيلِ اللَّهِ كَمَثَلِ حَبَّةٍ أَنبَتَتْ سَبْعَ سَنَابِلَ فِي كُلِّ سُنبُلَةٍ مِّائَةُ حَبَّةٍ",
      body: "Perumpamaan orang yang menginfakkan hartanya di jalan Allah seperti **sebutir biji** yang menumbuhkan tujuh tangkai, pada setiap tangkai ada **seratus biji**.",
      title: "QS. Al-Baqarah: 261",
    } },
    { reveal: {
      body: "Satu kebaikan, **700 kali balasan**. Dan Allah bahkan bisa melipatgandakan lebih dari itu bagi siapa yang Dia kehendaki. Sedekah bukan mengurangi harta — **tapi menanamnya**.",
    } },
    { insight: {
      title: "Sedekah itu investasi terbaik",
      body: "Rasulullah ﷺ bersabda: **\"Sedekah itu tidak mengurangi harta.\"** (HR. Muslim). Setiap rupiah yang kamu keluarkan di jalan Allah, bukan hilang — tapi **disimpan di tempat yang paling aman**.",
    } },
    { engagement: {
      title: "Kapan terakhir kamu sedekah dan merasakan ketenangan hatinya?",
      body: "Gak harus besar. **Yang penting ikhlas.** Yuk share ayat ini sebagai pengingat! 🤲",
    } },
  ]),
  related: ["sabar-baqarah-153"],
};
